import React from 'react';
import { ShimmerComponent } from '@zydalabs/storefront-components';

import { StyledSectionShimmer } from 'common/styles';
import { StyledShimmerWrapper } from './style';

const ProductDetailsShimmer: React.FC = () => (
  <StyledShimmerWrapper>
    <StyledSectionShimmer>
      <ShimmerComponent.ShimmerEffect>
        <ShimmerComponent.NoAnimationBox width={1}>
          <ShimmerComponent.Rect width="100%" height={300} mb={2} />
        </ShimmerComponent.NoAnimationBox>
      </ShimmerComponent.ShimmerEffect>
      <ShimmerComponent.ShimmerEffect>
        <ShimmerComponent.Rect height={20} width="100%" my={1} />
      </ShimmerComponent.ShimmerEffect>
      <ShimmerComponent.ShimmerEffect>
        <ShimmerComponent.Rect height={40} width="100%" my={1} />
      </ShimmerComponent.ShimmerEffect>
      <ShimmerComponent.ShimmerEffect>
        <ShimmerComponent.Rect height={20} width="30%" my={2} />
      </ShimmerComponent.ShimmerEffect>
    </StyledSectionShimmer>

    <StyledSectionShimmer>
      <ShimmerComponent.ShimmerEffect>
        <ShimmerComponent.NoAnimationBox width={1} justifyContent="space-between">
          <ShimmerComponent.Rect height={20} width="40%" my={2} />
          <ShimmerComponent.Rect height={20} my={2} />
        </ShimmerComponent.NoAnimationBox>
      </ShimmerComponent.ShimmerEffect>

      <ShimmerComponent.ShimmerEffect>
        <ShimmerComponent.Rect height={20} width="30%" my={2} />
      </ShimmerComponent.ShimmerEffect>

      {Array.from([...Array(3)].keys()).map(num => (
        <ShimmerComponent.ShimmerEffect key={num}>
          <ShimmerComponent.NoAnimationBox width={1} alignItems="center" mt={1}>
            <ShimmerComponent.NoAnimationBox width={1} height={20} alignItems="center" mt={4}>
              <ShimmerComponent.Circle />
              <ShimmerComponent.Rect width="40%" mx={2} />
            </ShimmerComponent.NoAnimationBox>
            <ShimmerComponent.Rect height={20} width="15%" mx={2} />
          </ShimmerComponent.NoAnimationBox>
        </ShimmerComponent.ShimmerEffect>
      ))}
    </StyledSectionShimmer>

    <StyledSectionShimmer>
      <ShimmerComponent.ShimmerEffect>
        <ShimmerComponent.Rect height={20} width="60%" my={2} />
      </ShimmerComponent.ShimmerEffect>
      <ShimmerComponent.ShimmerEffect>
        <ShimmerComponent.Rect height={40} width="100%" my={2} />
      </ShimmerComponent.ShimmerEffect>
    </StyledSectionShimmer>

    <StyledSectionShimmer>
      <ShimmerComponent.ShimmerEffect>
        <ShimmerComponent.Rect height={40} width="100%" my={2} />
      </ShimmerComponent.ShimmerEffect>
    </StyledSectionShimmer>
  </StyledShimmerWrapper>
);

export default ProductDetailsShimmer;
